import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { UpdateEntityStateMessage } from './preferred-profession-specialty.messages';
import { selectPreferredProfessionSpecialtyTempState } from './preferred-profession-specialty.selectors';
import { UpdateEntityStatePreferredProfessionSpecialtySignal } from './preferred-profession-specialty.signals';

@Injectable()
export class PreferredProfessionSpecialtyEffects {
  updateEntityStatePreferredProfessionSpecialtySignal$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateEntityStatePreferredProfessionSpecialtySignal>(
        UpdateEntityStatePreferredProfessionSpecialtySignal.TYPE,
      ),
      concatLatestFrom(() => this.store.pipe(select(selectPreferredProfessionSpecialtyTempState))),
      map(
        ([_, preferredProfessionSpecialtyTempState]) =>
          new UpdateEntityStateMessage({
            preferredProfessionSpecialtyTempState,
          }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
  ) {}
}
